module.exports = __webpack_public_path__ + "static/Rosewater7-feae42c50deda840bd5e278f1dca0335.webp";